import { Menu } from '@interfaces/menuInterfaces'
/**
 * Hàm chính trả ra 3 đối tượng từ danh sách menu
 */
export const processMobileMenu = (menus: Menu[]) => {
    // Lọc menu mobile và active
    const webMenus = menus.filter(menu => menu.type === 'WEBAPP' && menu.isActive)
    
    const webUrls = webMenus
        .map(menu => menu.url)
        .filter(url => url)
    
    const webChucNangs = webMenus
        .map(menu => ({
            url: menu.url,
            chucNangs: menu.chucNangs.map(chucNang => chucNang.ma)
        }))
        .filter(item => item.url && item.chucNangs.length > 0)
    
    const webChucNangAll = webMenus
        .flatMap(menu => menu.chucNangs.map(chucNang => chucNang.ma))
        .filter((value, index, self) => self.indexOf(value) === index)
    
    return {
        webUrls,
        webChucNangs,
        webChucNangAll
    }
}
